import React from 'react';
import { CheckCircleIcon, StarIcon, ArrowRightIcon, ClockIcon, PenToolIcon, LayoutIcon, SparklesIcon } from 'lucide-react';
export function SalesCopy() {
  return <div className="cosmic-bg" data-id="element-124">
      {/* Section - What's Included (Product Card) */}
      <section className="relative z-10 py-16 md:py-24 px-4" data-id="element-125">
        <div className="max-w-3xl mx-auto" data-id="element-126">
          {/* Section Header */}
          <div className="text-center mb-10" data-id="element-127">
            <div className="inline-flex items-center gap-2 bg-[#F5C842]/15 border border-[#F5C842]/30 rounded-full px-5 py-1.5 mb-5" data-id="element-128">
              <StarIcon className="w-4 h-4 text-[#F5C842]" data-id="element-129" />
              <span className="text-[#F5C842] font-bold text-sm uppercase tracking-wider" data-id="element-130">
                Para Astrólogas Profesionales
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-white mb-3" data-id="element-131">
              ¿Qué incluye el{' '}
              <span className="text-gold-gradient" data-id="element-132">Sistema Pro</span>?
            </h2>
            <p className="text-lg text-white/70 max-w-xl mx-auto" data-id="element-133">
              Dentro de{' '}
              <strong className="text-white" data-id="element-134">SISTEMA PRO CARTAS NATALES</strong>{' '}
              encontrás todo lo que necesitás para entregar informes
              profesionales con confianza.
            </p>
          </div>

          {/* Product Card */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-2xl shadow-black/30" data-id="element-135">
            {/* Card Image Banner */}
            <div className="relative h-48 md:h-56 overflow-hidden" data-id="element-136">
              <img src="https://cdn.magicpatterns.com/uploads/egSk7yA3Ya5VsD7DeFvht1/Mockup_principal.png" alt="Sistema Pro Cartas Natales" className="w-full h-full object-cover object-top" data-id="element-137" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1a1030] via-[#1a1030]/40 to-transparent" data-id="element-138" />

              {/* Badge */}
              <div className="absolute top-4 right-4 bg-[#F5C842] text-[#0f0a1e] text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1" data-id="element-139">
                <StarIcon className="w-3 h-3" data-id="element-140" />
                SISTEMA COMPLETO
              </div>

              {/* Product Name Overlay */}
              <div className="absolute bottom-4 left-5 flex items-center gap-2.5" data-id="element-141">
                <div className="w-9 h-9 bg-[#F5C842] rounded-lg flex items-center justify-center" data-id="element-142">
                  <StarIcon className="w-5 h-5 text-[#0f0a1e]" data-id="element-143" />
                </div>
                <span className="text-white font-bold text-lg md:text-xl drop-shadow-lg" data-id="element-144">
                  Sistema Pro Cartas Natales
                </span>
              </div>
            </div>

            {/* Card Body */}
            <div className="p-6 md:p-8" data-id="element-145">
              <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-6" data-id="element-146">
                Material completo y estructurado para astrólogas profesionales.
                Todo lo que necesitás para armar informes de carta natal con
                calidad premium, sin perder horas y sin improvisar.
              </p>

              {/* Features Grid - 2 columns */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 mb-6" data-id="element-147">
                <div className="flex items-center gap-2.5" data-id="element-148">
                  <CheckCircleIcon className="w-5 h-5 text-[#D4AF37] flex-shrink-0" data-id="element-149" />
                  <span className="text-gray-800 text-sm md:text-base" data-id="element-150">
                    Plantillas de informes editables
                  </span>
                </div>
                <div className="flex items-center gap-2.5" data-id="element-151">
                  <CheckCircleIcon className="w-5 h-5 text-[#D4AF37] flex-shrink-0" data-id="element-152" />
                  <span className="text-gray-800 text-sm md:text-base" data-id="element-153">
                    Interpretaciones base listas
                  </span>
                </div>
                <div className="flex items-center gap-2.5" data-id="element-154">
                  <CheckCircleIcon className="w-5 h-5 text-[#D4AF37] flex-shrink-0" data-id="element-155" />
                  <span className="text-gray-800 text-sm md:text-base" data-id="element-156">
                    Estructura profesional paso a paso
                  </span>
                </div>
                <div className="flex items-center gap-2.5" data-id="element-157">
                  <CheckCircleIcon className="w-5 h-5 text-[#D4AF37] flex-shrink-0" data-id="element-158" />
                  <span className="text-gray-800 text-sm md:text-base" data-id="element-159">
                    Diseño visual premium
                  </span>
                </div>
                <div className="flex items-center gap-2.5" data-id="element-160">
                  <CheckCircleIcon className="w-5 h-5 text-[#D4AF37] flex-shrink-0" data-id="element-161" />
                  <span className="text-gray-800 text-sm md:text-base" data-id="element-162">
                    Formato listo para entregar
                  </span>
                </div>
                <div className="flex items-center gap-2.5" data-id="element-163">
                  <CheckCircleIcon className="w-5 h-5 text-[#D4AF37] flex-shrink-0" data-id="element-164" />
                  <span className="text-gray-800 text-sm md:text-base" data-id="element-165">
                    Material organizado por secciones
                  </span>
                </div>
              </div>
            </div>

            {/* Card Footer */}
            <div className="border-t border-gray-200 px-6 md:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-166">
              <p className="text-gray-500 text-sm" data-id="element-167">
                Todo incluido · Acceso inmediato · Descarga digital
              </p>
              <a href="#comprar" className="inline-flex items-center gap-2 bg-gradient-to-r from-[#D4AF37] to-[#F5C842] text-[#0f0a1e] font-bold px-6 py-2.5 rounded-full text-sm hover:opacity-90 transition-opacity whitespace-nowrap" data-id="element-168">
                Quiero esto <ArrowRightIcon className="w-4 h-4" data-id="element-169" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Feature Panels */}
      <section className="relative z-10 py-12 md:py-20 px-4" data-id="element-170">
        <div className="max-w-5xl mx-auto" data-id="element-171">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-8" data-id="element-172">
            {/* Panel 1 - Ahorro de Tiempo */}
            <div className="flex flex-col items-center text-center" data-id="element-173">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center mb-4 shadow-lg shadow-blue-500/20" data-id="element-174">
                <ClockIcon className="w-8 h-8 md:w-10 md:h-10 text-white" data-id="element-175" />
              </div>
              <h4 className="text-white font-bold text-base md:text-lg mb-2" data-id="element-176">
                Ahorro de Tiempo
              </h4>
              <p className="text-white/60 text-sm leading-relaxed" data-id="element-177">
                No pierdas horas armando informes. Tenés todo listo para
                completar y entregar a tus clientas.
              </p>
            </div>

            {/* Panel 2 - 100% Editable */}
            <div className="flex flex-col items-center text-center" data-id="element-178">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center mb-4 shadow-lg shadow-orange-500/20" data-id="element-179">
                <PenToolIcon className="w-8 h-8 md:w-10 md:h-10 text-white" data-id="element-180" />
              </div>
              <h4 className="text-white font-bold text-base md:text-lg mb-2" data-id="element-181">
                100% Editable
              </h4>
              <p className="text-white/60 text-sm leading-relaxed" data-id="element-182">
                Archivos editables para que puedas adaptarlos a tu estilo
                personal y a cada clienta.
              </p>
            </div>

            {/* Panel 3 - Diseño Profesional */}
            <div className="flex flex-col items-center text-center" data-id="element-183">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-gradient-to-br from-rose-400 to-red-500 flex items-center justify-center mb-4 shadow-lg shadow-red-500/20" data-id="element-184">
                <LayoutIcon className="w-8 h-8 md:w-10 md:h-10 text-white" data-id="element-185" />
              </div>
              <h4 className="text-white font-bold text-base md:text-lg mb-2" data-id="element-186">
                Diseño Profesional
              </h4>
              <p className="text-white/60 text-sm leading-relaxed" data-id="element-187">
                Informes con apariencia premium que transmiten confianza y
                elevan tu imagen profesional.
              </p>
            </div>

            {/* Panel 4 - Versatilidad Total */}
            <div className="flex flex-col items-center text-center" data-id="element-188">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-gradient-to-br from-purple-400 to-violet-600 flex items-center justify-center mb-4 shadow-lg shadow-violet-500/20" data-id="element-189">
                <SparklesIcon className="w-8 h-8 md:w-10 md:h-10 text-white" data-id="element-190" />
              </div>
              <h4 className="text-white font-bold text-base md:text-lg mb-2" data-id="element-191">
                Versatilidad Total
              </h4>
              <p className="text-white/60 text-sm leading-relaxed" data-id="element-192">
                Ideal para cualquier tipo de carta natal: solar, lunar,
                revolución, sinastría y más.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}